interface Props {
  content: string;
}

export function HtmlContent({ content }: Props) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: parseHTML(content) }}
      className="html-content"
    />
  );
}

function parseHTML(html: string) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
